// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/technical-record-retention-and-transfer.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/technical-record-retention-and-transfer/technical-record-retention-and-transfer.js';

mount([g0]);
